// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx","743":"component---src-pages-using-typescript-tsx"}[chunkId] || chunkId) + "-" + {"245":"c0bf86f6418c21d47eee","453":"d71594eaab08b88db530","522":"4746fc9a24dcb85d4ee0","743":"f0271a7c901f36dc86a7"}[chunkId] + ".js";
};